import React, { useEffect, useState } from 'react'
import { InterfaceRoutes } from '../../interfaces/interfaceRoutes'
import './publicidad-historia.css'
import { getFgPublicidadHistoria } from '../../config/services/strapi/publicidad-historia'
import TextSkeleton from '../../components/Skeleton/TextSkeleton'
import { getMediaUrl, normalizeHeroImages } from '../../helpers/strapiMedia'
import { renderBlocksAsParagraphs } from '../../helpers/renderBlocksAsParagraphs'
import { useSimpleCarousel } from '../../hooks/useSimpleCarousel'
import HeroCarousel from '../../components/hero-carousel/HeroCarousel'

const PublicidadHistoria = (_props: InterfaceRoutes) => {
  const [loading, setLoading] = useState(true)
  const [carouselImages, setCarouselImages] = useState<any[]>([])
  const [descripcion, setDescripcion] = useState<any>(null)
  const [detalle, setDetalle] = useState<any>(null)
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null)
  const { activeSlide, goToSlide, trackRef, slideRefs } = useSimpleCarousel(carouselImages.length)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getFgPublicidadHistoria()
        const attrs = response?.attributes || response || {}

        setCarouselImages(normalizeHeroImages(attrs?.hero, 'Publicidad Historia'))
        setDescripcion(attrs?.descripcion || null)
        setDetalle(attrs?.detalle || null)

        // usar el campo 'archivo' para la descarga
        const url = attrs?.archivo ? getMediaUrl(attrs.archivo) : null
        setDownloadUrl(url || null)
      } catch (error) {
        console.error('Error cargando Publicidad Historia:', error)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return (
    <div className="publicidad-page">
      <HeroCarousel
        images={carouselImages}
        loading={loading}
        activeSlide={activeSlide}
        goToSlide={goToSlide}
        trackRef={trackRef}
        slideRefs={slideRefs}
        carouselAriaLabel="Carrusel Publicidad Historia"
        trackAriaLabel="Galería desplazable de imágenes"
        dotsAriaLabel="Indicadores carrusel"
      />

      <div id="main-content">
        <div className="page-content qs-content">
          <div className="qs-columns">
            <div className="qs-col">
              <h2 className="ph-main-title">Publicidad para una historia</h2>
              {loading ? <TextSkeleton /> : renderBlocksAsParagraphs(descripcion, 'ph-desc')}

              {downloadUrl ? (
                <div className="qs-download-wrap">
                  <a className="qs-download-btn" href={downloadUrl} target="_blank" rel="noreferrer">Descargar el libro</a>
                </div>
              ) : null}
            </div>

            <div className="qs-col">
              {loading ? <TextSkeleton /> : renderBlocksAsParagraphs(detalle, 'ph-det')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicidadHistoria
